"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FingerDescriptionDescriptionEnum = exports.FingerDescriptionFingerEnum = exports.FingerDescriptionToJSON = exports.FingerDescriptionFromJSONTyped = exports.FingerDescriptionFromJSON = void 0;
const runtime_1 = require("../runtime");
function FingerDescriptionFromJSON(json) {
    return FingerDescriptionFromJSONTyped(json, false);
}
exports.FingerDescriptionFromJSON = FingerDescriptionFromJSON;
function FingerDescriptionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'finger': !runtime_1.exists(json, 'finger') ? undefined : json['finger'],
        'description': json['description'],
    };
}
exports.FingerDescriptionFromJSONTyped = FingerDescriptionFromJSONTyped;
function FingerDescriptionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'finger': value.finger,
        'description': value.description,
    };
}
exports.FingerDescriptionToJSON = FingerDescriptionToJSON;
/**
* @export
* @enum {string}
*/
var FingerDescriptionFingerEnum;
(function (FingerDescriptionFingerEnum) {
    FingerDescriptionFingerEnum["THUMB"] = "THUMB";
    FingerDescriptionFingerEnum["INDEX"] = "INDEX";
    FingerDescriptionFingerEnum["MIDDLE"] = "MIDDLE";
    FingerDescriptionFingerEnum["RING"] = "RING";
    FingerDescriptionFingerEnum["LITTLE"] = "LITTLE";
    FingerDescriptionFingerEnum["INVALIDVALUE"] = "_INVALID_VALUE";
})(FingerDescriptionFingerEnum = exports.FingerDescriptionFingerEnum || (exports.FingerDescriptionFingerEnum = {}));
/**
* @export
* @enum {string}
*/
var FingerDescriptionDescriptionEnum;
(function (FingerDescriptionDescriptionEnum) {
    FingerDescriptionDescriptionEnum["BANDAGED"] = "BANDAGED";
    FingerDescriptionDescriptionEnum["MISSING"] = "MISSING";
    FingerDescriptionDescriptionEnum["PRESENT"] = "PRESENT";
    FingerDescriptionDescriptionEnum["INVALIDVALUE"] = "_INVALID_VALUE";
})(FingerDescriptionDescriptionEnum = exports.FingerDescriptionDescriptionEnum || (exports.FingerDescriptionDescriptionEnum = {}));
//# sourceMappingURL=FingerDescription.js.map